var path = '/templates/projects.site_reports/device_segment.html';
var html = "<div class=\"panel panel-default\" ng-if=$ctrl.project.thisMonthStat><div class=panel-heading><h3 class=panel-title>{{ 'projectsSiteReports.device_segment.debaisugoto_no_haishin' | translate }}</h3></div><div class=panel-body><highchart config=$ctrl.chartConfig></highchart></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.site_reports/device_segment.html
// module id = 1590
// module chunks = 0